import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MainNavbarComponent } from './core/components/main-navbar/main-navbar.component';
import { CompanyPdfReportComponent } from './features/results/components/company-pdf-report/company-pdf-report.component';
import { ThemePdfReportComponent } from './features/results/components/theme-pdf-report/theme-pdf-report.component';
import { ReportJobsService } from './features/results/services/report-jobs.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, MainNavbarComponent, CompanyPdfReportComponent, ThemePdfReportComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'frontend';
  reportJobs = inject(ReportJobsService);
  trackByTabId = (_: number, t: { tabId: string }) => t.tabId;
}
